import { getIntegrationAuthenticationUrl } from 'apollo/accounts.query';

export const authAccountWithIntegration = async (variables, handleError) => {
  try {
    const response = await getIntegrationAuthenticationUrl(variables);
    if (!response.errors && response.data.generateIntegrationAuthUrl.authUrl) {
      window.location.href = response.data.generateIntegrationAuthUrl.authUrl;
    } else {
      handleError("Sorry, we couldn't authenticate your account, please try again.");
    }
  } catch (err) {
    handleError("Sorry, we couldn't authenticate your account, please try again.");
  }
};
